import { CellPlugin } from '@react-page/editor';
import React from 'react';

// use a type here, not an interface
type Data = {
  text: string,
  fontColor: string,
  fontSize: string,
  fontStyle: string,
  fontWeight: string,
  textAlign: string,
  textDecoration: string,
  textTransform: string,
  margin: string,
  padding: string,
}

const FONT_COLOR = '#414141';
const FONT_SIZE = '16px';
const FONT_STYLE = 'normal';
const FONT_WEIGHT = 'bold';
const TEXT_ALIGN = 'left';
const TEXT_DECORATION = 'none';
const TEXT_TRANSFORM = 'none';
const MARGIN = '0px';
const PADDING = '0px';

const checkStyleForDefault = (style:string, defaultStyle:string) => {
  return style && style !== ''?style:defaultStyle;
}

const checkStyleForDefault2 = (style:number|undefined, defaultStyle:number) => {
  return style?style:defaultStyle;
}

const checkStyleForDefault3 = (defaultStyle:string) => {
  return defaultStyle as any;
}

const HeaderPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
        <h2 style={{
          color:checkStyleForDefault(data.fontColor, FONT_COLOR),
          fontSize:checkStyleForDefault(data.fontSize, FONT_SIZE),
          fontStyle:checkStyleForDefault(data.fontStyle, FONT_STYLE),
          fontWeight:checkStyleForDefault3(data.fontWeight),
          lineHeight:'1.5',
          textAlign:checkStyleForDefault3(data.textAlign),
          textDecoration:checkStyleForDefault3(data.textDecoration),
          textTransform:checkStyleForDefault3(data.textTransform),
          margin:checkStyleForDefault(data.margin, MARGIN),
          padding:checkStyleForDefault(data.padding, PADDING),
        }}>{data.text}</h2>
  ),
  id: 'headerPlugin',
  title: 'Heading',
  description: 'H1, H2, H3 text.',
  version: 1,
  controls: [
    {
      title: 'Labels',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            text: {
              type: 'string',
              default: '',
            },
          },
          required: ['text'],
        },
      },
    },
    {
      title: 'Styles',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            fontColor: {
              type: 'string',
              default: FONT_COLOR,
            },
            fontSize: {
              type: 'string',
              default: FONT_SIZE,
            },
            fontStyle: {
              type: 'string',
              default: FONT_STYLE,
            },
            fontWeight: {
              type: 'string',
              default: FONT_WEIGHT,
            },
            textAlign: {
              type: 'string',
              default: TEXT_ALIGN,
            },
            textDecoration: {
              type: 'string',
              default: TEXT_DECORATION,
            },
            textTransform: {
              type: 'string',
              default: TEXT_TRANSFORM,
            },
            margin: {
              type: 'string',
              default: MARGIN,
            },
            padding: {
              type: 'string',
              default: PADDING,
            },
          },
        },
      },
    },
  ]
};

export default HeaderPlugin;